import * as React from 'react';
import {
  NavLink as RRNavLink,
  NavLinkProps as RRNavLinkProps,
} from 'react-router-dom';
import { NavLink } from 'reactstrap';

export default class RouterNavLink extends React.Component<RRNavLinkProps> {
  render() {
    const { children, ...rest } = this.props;
    return (
      <NavLink tag={RRNavLink} {...rest}>
        <span>{children}</span>
      </NavLink>
    );
  }
}
